<template>
    <v-dialog v-model="loading" fullscreen transition="dialog-bottom-transition" hide-overlay persistent>
        <v-container class="fill-height primary" color="primary" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card color="primary" dark flat>
                        <v-img :src="require('@/assets/logo-gau.png')" class="my-3" contain height="200"></v-img>
                        <v-card-text>
                            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-dialog>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean
        }
    },

    created() {},
}
</script>